import { create } from "zustand";

interface AudioPlayerState {
  playingId: string | null;
  progress: number;
  durationSeconds: number;
  play: (id: string, url: string, startFraction?: number) => void;
  pause: () => void;
  seek: (fraction: number) => void;
}

const audio = new Audio();
let rafId: number | null = null;
let targetSeekFraction: number | null = null;

export const useAudioPlayer = create<AudioPlayerState>((set, get) => {
  const updateProgress = () => {
    if (!audio.paused && audio.duration) {
      set({ progress: audio.currentTime / audio.duration });
      rafId = requestAnimationFrame(updateProgress);
    }
  };

  audio.onplay = () => {
    if (rafId !== null) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updateProgress);
  };
  
  audio.onpause = () => {
    if (rafId !== null) cancelAnimationFrame(rafId);
  };

  audio.onended = () => {
    set({ playingId: null, progress: 0 });
    if (rafId !== null) cancelAnimationFrame(rafId);
  };

  audio.onloadedmetadata = () => {
    set({ durationSeconds: audio.duration });
    if (targetSeekFraction !== null) {
      audio.currentTime = targetSeekFraction * audio.duration;
      set({ progress: targetSeekFraction });
      targetSeekFraction = null;
    }
  };

  return {
    playingId: null,
    progress: 0,
    durationSeconds: 0,
    play: (id, url, startFraction) => {
      const state = get();
      if (state.playingId === id) {
        if (audio.paused) {
          audio.play().catch(console.error);
        }
      } else {
        audio.src = url;
        if (startFraction !== undefined) {
           targetSeekFraction = startFraction;
        } else {
           targetSeekFraction = null;
        }
        audio.play().catch(console.error);
        set({ playingId: id, progress: startFraction || 0 });
      }
    },
    pause: () => {
      audio.pause();
      set({ playingId: null });
    },
    seek: (fraction) => {
      if (audio.duration) {
        audio.currentTime = fraction * audio.duration;
        set({ progress: fraction });
      }
    }
  };
});
